import { Button, Col, Form, Input, Row } from 'antd';

import { AgreementFormItem } from './common';

import './index.less';

const FormBindPhone = (props: any) => {
  const {
    form,
    onFinish,
    onFieldsChange,
    enable,
    codeBtnDisabled,
    onSendCode,
    btnContent,
    isDisabledSubmit,
    loadingBtn,
  } = props;

  return (
    <>
      <div className={'headerGroup'}>
        <div>{'绑定手机'}</div>
      </div>

      <div className={'loginForm'}>
        <Form
          form={form}
          size={'large'}
          name="register"
          onFinish={onFinish}
          onFieldsChange={onFieldsChange}
          scrollToFirstError
        >
          {/*账号信息*/}
          <Form.Item
            name="username"
            label=""
            rules={[
              { required: true, message: '请输入手机号' },
              { pattern: /^1[23456789]\d{9}$/, message: '请输入正确的手机号' },
            ]}
          >
            <Input placeholder={'请输入手机号'} />
          </Form.Item>

          <Form.Item label="">
            <Row gutter={8}>
              <Col span={12}>
                <Form.Item
                  name="code"
                  noStyle
                  rules={[
                    { required: true, message: '请输入验证码' },
                    { pattern: /^[0-9]{6}$/, message: '请输入正确的验证码' },
                  ]}
                >
                  <Input placeholder={'请输入验证码'} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Button
                  className="codeBtn"
                  type={enable ? 'primary' : 'default'}
                  block
                  disabled={codeBtnDisabled}
                  onClick={onSendCode}
                >
                  {btnContent}
                </Button>
              </Col>
            </Row>
          </Form.Item>

          {/* 用户协议 */}
          <AgreementFormItem />

          <Form.Item>
            <Button
              type="primary"
              disabled={isDisabledSubmit}
              htmlType="submit"
              loading={loadingBtn}
              block
            >
              确定
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default FormBindPhone;
